import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import CertificateOfStudiesRepository from '../../../../repositories/CertificateOfStudiesRepository';
import CertificateOfStudiesDataRepository from '../../../../../data/repositories/CertificateOfStudiesDataRepository';
import config from '../../../../../core/config/config';
import XCheckpointManager from '@/core/managers/xcheckpointManager';
import { listProcedures } from '../../getStudentProcedureStatus/procedure-list';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.REGISTER_CERTIFICATE_OF_STUDIES_REQUEST });
    const certificateOfStudiesRepository: CertificateOfStudiesRepository =
      new CertificateOfStudiesDataRepository();
    const procedure: any = listProcedures.find(
      (item: any) => item.procedureId === action.procedureId
    );
    if (procedure)
      XCheckpointManager.registerStart(`${procedure?.name} - register`);

    const certificateOfStudiesResponse = yield call(
      certificateOfStudiesRepository.register,
      action.procedureId,
      action.period.value,
      action.period.label,
      action.program,
      action.weightedAverage,
      action.hasDebts,
      action.CodCarrera
    );
    if (procedure)
      XCheckpointManager.registerEnd(`${procedure?.name} - register`);
    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);
    if (!certificateOfStudiesResponse) {
      yield put({
        type: Types.REGISTER_CERTIFICATE_OF_STUDIES_FAILURE,
        error: 'No se pudo leer los datos del trámite.'
      });
      return;
    }
    // yield put({
    //   type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    // });
    yield put({
      type: Types.REGISTER_CERTIFICATE_OF_STUDIES_SUCCESS,
      requestId: certificateOfStudiesResponse.requestId,
      data: certificateOfStudiesResponse
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_CERTIFICATE_OF_STUDIES_FAILURE,
      error:
        'Ocurrió un error al momento de leer los datos del trámite solicitado.'
    });
  }
}
